
export function BlogHero() {
  return (
    <section className="bg-gradient-to-r from-green-50 to-green-100 py-12 sm:py-16 lg:py-20">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold font-primary text-gray-800 mb-4 sm:mb-6">
            Blog
          </h1>
          <p className="text-base sm:text-lg lg:text-xl font-secondary text-gray-600 max-w-4xl mx-auto px-4">
            Artigos, dicas e informações sobre nutrição e bem-estar para transformar sua vida
          </p>
        </div>
      </div>
    </section>
  );
}
